import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * IP广播列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	audioList( params={} ) {
		return request({
	    url: baseUrl + '/device/breakers',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 路灯添加
	**/
	audioAdd(data){
		return request({
			url: baseUrl + '/device/breakers',
			method:'POST',
			data
		})
	},
	/**
	 * IP广播编辑
	**/
	audioEdit(id,data){
		return request({
			url: baseUrl + '/device/breakers/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * IP广播删除
	**/
	audioDel(id){
		return request({
			url: baseUrl + '/device/breakers/'+id,
			method:'DELETE'
		})
	}
}